<template lang="pug">
  v-flex(xs12)
    v-container.py-0.elevation-1.white(fluid)
    v-container.pt-0.pb-0(fluid grid-list-lg)
      v-layout(fill-height row-wrap)
        v-layout(wrap)
          v-flex
            v-form(ref="form" v-model="valid")
              v-flex(xs12)
                v-layout.row-title(wrap)
                  v-flex(xs12)
                    h3 General Information
                    p.pb-1 Only use your personal name. Do NOT use a business name.
                v-layout(wrap)
                  v-flex(xs6)
                    v-text-field(
                      label="First Name*"
                      v-model="form.firstName"
                      :rules="[rules.required]"
                      browser-autocomplete="disable"
                      required
                    )
                  v-flex(xs6)
                    v-text-field(
                      label="Last Name*"
                      v-model="form.lastName"
                      :rules="[rules.required]"
                      browser-autocomplete="disable"
                      required
                    )
              v-flex.row-thin(xs12)
                v-layout(wrap)
                  v-flex(xs6)
                    v-text-field(
                      label="Email*"
                      v-model="form.email"
                      :rules="[rules.email]"
                      required
                    )
              v-flex(xs12)
                v-layout.row-title(wrap)
                  v-flex.mb-2(xs12)
                    h3 Please enter a valid direct mobile number that you own. Do NOT use your custom texting number or a VOIP number such as Google voice.
                v-layout(wrap)
                  v-flex(xs6)
                    v-text-field(
                      label="Cell Phone #*"
                      v-model="form.phone"
                      :rules="[rules.required, rules.mobileNumber, rules.customNumber, rules.phone]"
                      browser-autocomplete="disable"
                      required
                      @keyup="isMobileNumberValid = true"
                      @blur="cleanPhoneInput('phone', form.phone)"
                    )
                  v-flex(xs6)
                    v-text-field(
                      label="Confirm Cell Phone #*"
                      v-model="form.phoneConfirm"
                      :rules="[rules.required, phoneMatch]"
                      browser-autocomplete="disable"
                      required
                      @blur="cleanPhoneInput('phoneConfirm', form.phoneConfirm)"
                    )
              v-flex(xs12)
                v-layout.row-title(wrap)
                  v-flex.row-thin(xs12)
                    h3 Address
                    p Only use your personal address or PO Box. Do NOT use a shared office address.
                v-layout(wrap)
                  v-flex.row-thin(xs12)
                    v-layout(row wrap)
                      v-flex(xs6)
                        v-select(
                          label="Country*"
                          v-model="form.country"
                          :rules="[rules.required]"
                          browser-autocomplete="disable"
                          :items="countries"
                          item-text="text"
                          item-value="value"
                          @change="onCountryChange"
                          required
                        )
                  v-flex.row-thin(xs12)
                    v-layout(row wrap)
                      v-flex(xs6)
                        v-text-field(
                          label="Street or PO Box*"
                          v-model="form.street"
                          :rules="[rules.required, rules.address]"
                          browser-autocomplete="disable"
                          required
                        )
                      v-flex(xs6)
                        v-text-field(
                          label="City*"
                          v-model="form.city"
                          :rules="[rules.required]"
                          browser-autocomplete="disable"
                          required
                        )
                    v-layout(wrap)
                      v-flex.row-thin(xs12)
                        v-layout(wrap)
                          v-flex(xs6)
                            v-autocomplete(
                              label="State/Province/Region*"
                              v-model="form.state"
                              :rules="[rules.required]"
                              browser-autocomplete="disable"
                              :items="states"
                              item-text="text"
                              item-value="value"
                              required
                            )
                          v-flex(xs6)
                            v-text-field(
                              v-if="form.country === 'US'"
                              label="Zip Code*"
                              v-model="form.zipCode"
                              :rules="[rules.required, rules.zipCode]"
                              browser-autocomplete="disable"
                              mask="#####"
                              required
                            )
                            v-text-field(
                              v-else
                              label="Zip Code*"
                              v-model="form.zipCode"
                              :rules="[rules.required]"
                              browser-autocomplete="disable"
                              required
                            )
              v-flex(xs12)
                v-layout.row-title.row-thin(wrap)
                  v-flex(xs6)
                    h3.mt-2 Are you a real estate agent or broker?
                  v-flex(xs6)
                    v-radio-group.mt-1.radio-group(v-model="form.isBroker" row)
                      v-radio(label="Yes" :value="1")
                      v-radio(label="No" :value="0")
              v-flex.actions.xs12
                v-btn.action-btn(
                  v-if="!isFixBrand && !isLoading"
                  color="primary"
                  data-cy="next-campaign-step"
                  :disabled="shouldDisableSubmitBtn"
                  @click="save"
                ) Continue Registration
                v-btn.action-btn.retry-button(
                  v-else-if="!isLoading"
                  color="primary"
                  data-cy="next-campaign-step"
                  :disabled="shouldDisableSubmitBtn"
                  @click="save"
                ) Fix Identity Verification
                v-progress-circular(v-else indeterminate color="primary")
</template>
<script>
import ActionTitleBar from '@/Core/components/ActionTitleBar';
import { mapActions, mapState, mapMutations } from 'vuex';

import {
  EMAIL_REGEX,
  PHONE_WITHOUT_COUNTRY_REGEX,
  US_ZIP_CODE_REGEX,
  ADDRESS_PO_BOX_REGEX,
} from '@/Core/config/regex';

import { STATES_CA, STATES_US } from '../config/states';

import { ADDRESS_PO_BOX_MESSAGE, COUNTRIES, TEAM_SIZE, STEPS_SOLE_PROPRIETOR } from '../config';
import { REGISTRATION_STATES } from '../../Text/config/registrationStatus';

export default {
  name: 'RegisterSoleProprietorForm',
  components: {
    ActionTitleBar,
  },
  async mounted() {
    this.resetCampaignForm();
    if (!this.user) {
      await this.getUser();
    }
    if (this.user) {
      this.form.firstName = this.user.first_name;
      this.form.lastName = this.user.last_name;
      this.form.email = this.user.email;
      if (this.user.phone) {
        this.form.phone = this.normalizePhoneNumber(this.user.phone);
      }

      if (this.user.custom_number) {
        this.customNumberNormalized = this.normalizePhoneNumber(this.user.custom_number);
      }
    }
    if (!this.registerForm) {
      await this.getRegistrationData('sole_proprietor');
    }
    if (!this.registerForm) {
      await this.getRegistrationData('starter');
    }
    this.getForm();
  },
  data() {
    return {
      valid: true,
      disableSubmitBtn: false,
      isMobileNumberValid: true,
      customNumberNormalized: '',
      form: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        phoneConfirm: null,
        street: null,
        zipCode: null,
        city: null,
        country: null,
        state: null,
        brokerage: null,
        teamSize: null,
        isBroker: 1,
      },
      rules: {
        required: value => {
          return !!value || 'This field is required';
        },
        email: value => {
          return EMAIL_REGEX.test(value) || 'Invalid Email address';
        },
        phone: value => {
          return PHONE_WITHOUT_COUNTRY_REGEX.test(value) || 'Cell phone should be 10 numbers only, no characters';
        },
        mobileNumber: value => {
          return this.isMobileNumberValid || 'Cell phone is not a valid mobile number';
        },
        customNumber: value => {
          return (
            !this.user ||
            !this.user.custom_number ||
            this.customNumberNormalized !== value ||
            `This number should not be your custom texting number`
          );
        },
        address: value => {
          return !ADDRESS_PO_BOX_REGEX.test(value) || 'P.O. Box addresses are not accepted';
        },
        zipCode: value => {
          return US_ZIP_CODE_REGEX.test(value) || 'Invalid zip code';
        },
      },
      countries: COUNTRIES,
      statesCA: STATES_CA,
      statesUS: STATES_US,
      teamSize: TEAM_SIZE,
      addressPOBoxMessage: ADDRESS_PO_BOX_MESSAGE,
      steps: STEPS_SOLE_PROPRIETOR,
    };
  },
  computed: {
    ...mapState('userInformation', ['user']),
    ...mapState('registerSoleProprietorA2p', ['registerForm', 'isLoading']),
    ...mapState('conversations', ['registrationStatus10dlc']),
    states() {
      if (!this.form.country) return [];
      if (this.form.country === 'US') {
        return this.statesUS;
      }
      return this.statesCA;
    },
    shouldDisableSubmitBtn() {
      return this.isLoading || this.disableSubmitBtn || !this.valid;
    },
    isFixBrand() {
      return this.registrationStatus10dlc === REGISTRATION_STATES.BRAND_FAILED ||
        this.registrationStatus10dlc === REGISTRATION_STATES.CUSTOMER_PROFILE_FAILED ||
        this.registrationStatus10dlc === REGISTRATION_STATES.A2P_BUNDLE_FAILED ||
        this.registrationStatus10dlc === REGISTRATION_STATES.BRAND_TCR_FAILED;
    },
  },
  methods: {
    ...mapActions('registerSoleProprietorA2p', [
      'setStep',
      'setForm',
      'sendSoleProprieterRegistration',
      'getRegistrationData',
      'resetCampaignForm',
    ]),
    ...mapActions('userInformation', ['getUser']),
    ...mapActions('conversations', ['validatePhoneNumber', 'checkFor10dlcRegister']),
    ...mapMutations('registerSoleProprietorA2p', ['setIsLoading']),
    async save() {
      this.setIsLoading(true);
      try {
        this.isMobileNumberValid = await this.validatePhoneNumber(this.form.phone);

        if (!this.$refs.form.validate()) {
          return;
        }

        this.setForm({ form: this.form });
        if (!this.form.isBroker) {
          return this.setStep(this.steps.CAMPAIGN);
        }
        await this.sendSoleProprieterRegistration();
        await this.checkFor10dlcRegister('SOLE_PROPRIETOR');
        this.$emit('form:save');
      } catch (error) {
        console.error(error);
      } finally {
        this.setIsLoading(false);
      }
    },
    onCountryChange() {
      const { zipCode } = this.form;
      if (!zipCode || zipCode.length === 0) return;
      this.form.zipCode = '';
    },
    phoneMatch(confirmPhone) {
      const phoneNormalized = this.normalizePhoneNumber(this.form.phone);
      const confirmPhoneNormalized = this.normalizePhoneNumber(confirmPhone);
      if (confirmPhoneNormalized !== phoneNormalized) return 'The confirmation phone number does not match';
      return true;
    },
    getForm() {
      if (this.registerForm) {
        this.form = Object.assign(this.form, this.registerForm);
      }
    },
    normalizePhoneNumber(phone) {
      if (!phone) return "";

      var digits = this.onlyNumbers(phone);
      if (digits && digits.length > 10) {
        return digits.slice(-10);
      }

      if (digits) {
        return digits;
      }

      return "";
    },
    cleanPhoneInput(input, value) {
      if (!value) return;

      const numbers = this.onlyNumbers(value);

      switch (input) {
        case "phone":
          this.form.phone = numbers;
          break;
        case "phoneConfirm":
          this.form.phoneConfirm = numbers;
          break;
        default: break;
      }
    },
    onlyNumbers(value) {
      if (!value) return "";
      let cleaned = value.match(/\d/g);

      if (!cleaned) return "";

      return cleaned.join("");
    },
  },
};
</script>
<style scoped>
h3 {
  font-size: 14px !important;
}

.actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.row-title {
  margin-bottom: -18px !important;
}

.row-thin {
  margin-top: -10px !important;
}

.action-btn {
  text-transform: none;
}

.radio-group {
  margin-left: -30px;
}

.retry-button {
  text-transform: none;
}
</style>
